import React from 'react'

function Settings() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Settings</h1>
          <p className="text-gray-600">Manage your account preferences and configuration</p>
        </div>
        
        {/* Content Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {/* Profile Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-300">
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Profile Settings</h2>
            <p className="text-gray-600 mb-4">Update your personal information and preferences</p>
            <button className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-lg transition-all duration-300">
              Edit Profile
            </button>
          </div>
          
          {/* Security Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-300">
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Security</h2>
            <p className="text-gray-600 mb-4">Change password and manage security settings</p>
            <button className="w-full bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-lg transition-all duration-300">
              Manage Security
            </button>
          </div>
          
          {/* Notifications Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-300">
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Notifications</h2>
            <p className="text-gray-600 mb-4">Configure your notification preferences</p>
            <button className="w-full bg-orange-500 hover:bg-orange-600 text-white font-medium py-2 px-4 rounded-lg transition-all duration-300">
              Edit Notifications
            </button>
          </div>
        </div>
        
        {/* Additional Content Section */}
        <div className="mt-8 bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Account Overview</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-4 bg-blue-50 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Profile Completion</h3>
              <p className="text-2xl font-bold text-blue-600">85%</p>
            </div>
            <div className="text-center p-4 bg-green-50 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Account Status</h3>
              <p className="text-lg font-semibold text-green-600">Active</p>
            </div>
            <div className="text-center p-4 bg-purple-50 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Last Login</h3>
              <p className="text-sm text-gray-600">2 hours ago</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Settings


